import { motion } from "framer-motion";
import { ASSETS } from "./data";
import { LanguageSwitcher } from "./LanguageSwitcher";

export const Navbar = () => (
  <motion.header
    data-testid="site-navbar"
    initial={{ y: -60, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    className="fixed top-0 left-0 right-0 z-50 bg-white/85 backdrop-blur-md border-b border-slate-100"
  >
    <div className="neon-hairline" />
    <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
      <a
        href="https://ashleyfallspta.org"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="navbar-logo-link"
        className="flex items-center gap-3"
      >
        <img src={ASSETS.logo} alt="Ashley Falls PTA" className="h-10 w-10" />
        <span className="font-bold text-slate-900 tracking-tight text-sm sm:text-base notranslate whitespace-nowrap">
          Ashley Falls <span className="text-pink-500">PTA</span>
        </span>
      </a>
      <nav className="hidden md:flex items-center gap-8 text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">
        <a href="#tiers" data-testid="nav-tiers-link" className="hover:text-pink-500 transition-colors">Memberships</a>
        <a href="#impact" data-testid="nav-impact-link" className="hover:text-cyan-500 transition-colors">Impact</a>
      </nav>
      <div className="flex items-center gap-2 sm:gap-3">
        <LanguageSwitcher />
        <a
          href="#tiers"
          data-testid="navbar-join-button"
          className="px-4 sm:px-5 py-2 rounded-full bg-slate-900 text-cyan-300 text-xs font-bold uppercase tracking-widest hover:shadow-[0_0_18px_rgba(0,240,255,0.45)] transition-shadow"
        >
          Join Now
        </a>
      </div>
    </div>
  </motion.header>
);
